import React from 'react'

import TableRowLoading from './TableRowLoading'
import ComposeTableRow from './ComposeTableRow'
import { defaultValue, EMPTY_ROW_ID } from '../util'

const HoverTextWrapper = ({ hoverText, children }) => {
  if (hoverText) {
    return <div title={hoverText}>{children}</div>
  }
  return <>{children}</>
}

const LinkComponentWrapper = (props) => {
  const { LinkComponent, rowId, hoverText, linkToRow, rowOriginalData, linkRowCheck } = props

  const handleTableLinkRowClick = (e: any) => {
    if (e.target.id === 'rowSelect') {
      e.stopPropagation()
      e.preventDefault()
    }
  }
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.click()
    }
  }
  const linkTo = typeof props.linkToRow === 'function' ? linkToRow(rowOriginalData) : linkToRow
  //don't add link for empty row, added to get border
  if (LinkComponent && rowId !== EMPTY_ROW_ID) {
    return (
      <LinkComponent
        onClick={handleTableLinkRowClick}
        tabIndex={-1}
        to={linkTo}
        title={hoverText}
        onKeyDown={handleKeyDown}>
        {props.children}
      </LinkComponent>
    )
  }
  if (linkRowCheck && rowId !== EMPTY_ROW_ID) {
    return (
      <a onClick={handleTableLinkRowClick} tabIndex={-1} href={linkTo} onKeyDown={handleKeyDown}>
        {props.children}
      </a>
    )
  }
  return <>{props.children}</>
}


/**
 * It renders each row data
 * If data is available and not loading
 * And on loading it shows skeleton loader for that row
 **/
const RenderRow = (props) => {
  const row = props.rows[props.index]

  if (!props.showEmptyBorder && props.index >= props.totalCounts) {
    return null
  }

  if ((props.isPaginated || (props.itemStatusMap && props.itemStatusMap[props.index] === 'loaded')) && row) {
    props.prepareRow(row)
    const isSingleRowSelected = !props.isRowSelect && row.id === props.singleSelectedRowId
    const onHoverListCondition = props.onHoverListCondition

    let isRowDisabled = false
    let disabledMessage
    if (props.conditionalSingleSelect) {
      isRowDisabled = row.original[props.conditionalSingleSelect.key] === props.conditionalSingleSelect.value
      disabledMessage = props.conditionalSingleSelect.message
    } else if (props.rowDisableProp) {
      isRowDisabled = row.original[props.rowDisableProp.key] === props.rowDisableProp.value
    }

    const tableRowActionList = onHoverListCondition
      ? row.original[onHoverListCondition.key]
        ? onHoverListCondition.truthyList
        : onHoverListCondition.falsyList
      : props.tableRowActionList

    // const handleTableLinkRowClick = (e: any) => {
    //   if (e.target.id === 'rowSelect') {
    //     e.stopPropagation()
    //     e.preventDefault()
    //   }
    // }

    const linkRowCheck = !(props.fullRowSelect || typeof props.singleSelectedRowId === 'string') && props.linkToRow
    const { LinkComponent, linkToRow } = props
    let hoverText = ''

    if (props.onRowHoverText) {
      hoverText = props.onRowHoverText(row.original)
    }

    //rendering head within body , so need padding to shift rest element down
    let top = props.style.top
    if (props.canFreezeColumn || props.v2Features.tableRowAction || props.canFreezeCheckbox) {
      top = top + defaultValue.TABLE_HEAD_HEIGHT + (props.customRowAdd ? 60 : 0)
    }
    const styleFromFixedList = { ...props.style, top }

    const TableRowNodes = (
      <ComposeTableRow
        row={row}
        isRowDisabled={isRowDisabled}
        rowSelectCheckboxProp={props.rowSelectCheckboxProp}
        viewBy={props.viewBy}
        isSingleRowSelected={isSingleRowSelected}
        equalWidthColumns={props.equalWidthColumns}
        rowDisableProp={props.rowDisableProp}
        handleRowClick={props.handleRowClick}
        style={styleFromFixedList}
        tableRowActionList={tableRowActionList}
        toolTipPosFromRight={props.toolTipPosFromRight}
        disabledMessage={disabledMessage}
        listData={props.listData}
        isResizable={props.isResizable}
        columnWidthsObjectProp={props.columnWidthsObjectProp}
        columnWidthsObjectState={props.columnWidthsObjectState}
        columnResizing={props.columnResizing}
        isRowSelect={props.isRowSelect}
        canFreezeColumn={props.canFreezeColumn}
        v2Features={props.v2Features}
        tableWidth={props.tableWidth}
        rowActionData={props.rowActionData}
        updateRowActionData={props.updateRowActionData}
        actionsLayoutTestId={props.actionsLayoutTestId}
        actionsListTestId={props.actionsListTestId}
        totalCounts={props.totalCounts}
        customRowAdd={props.customRowAdd}
        canFreezeCheckbox={props.canFreezeCheckbox}
        tableWidthSmaller={props.tableWidthSmaller}
        columns={props.columns}
        emptyBorderRowHeight={props.emptyBorderRowHeight}
        showEmptyBorder={props.showEmptyBorder}
      />
    )

    return (
      <HoverTextWrapper hoverText={hoverText}>
        <LinkComponentWrapper
          LinkComponent={LinkComponent}
          linkRowCheck={linkRowCheck}
          rowOriginalData={row.original}
          rowId={row.id}
          hoverText={hoverText}
          linkToRow={linkToRow}>
          {TableRowNodes}
        </LinkComponentWrapper>
      </HoverTextWrapper>
    )

    // //don't add link for empty row, added to get border
    // if (LinkComponent && row.id !== EMPTY_ROW_ID) {
    //   return (
    //     <HoverTextWrapper hoverText={hoverText}>
    //       <LinkComponent
    //         onClick={handleTableLinkRowClick}
    //         tabIndex={-1}
    //         to={typeof props.linkToRow === 'function' ? linkToRow(row.original) : linkToRow}
    //         title={hoverText}
    //         onKeyDown={(e) => {
    //           if (e.key === 'Enter') {
    //             e.target.click()
    //           }
    //         }}
    //       >
    //         {TableRowNodes}
    //       </LinkComponent>
    //     </HoverTextWrapper>
    //   )
    // }

    // if (linkRowCheck && row.id !== EMPTY_ROW_ID) {
    //   return (
    //     <HoverTextWrapper hoverText={hoverText}>
    //       <a
    //         onClick={handleTableLinkRowClick}
    //         tabIndex={-1}
    //         href={typeof linkToRow === 'function' ? linkToRow(row.original) : linkToRow}
    //         onKeyDown={(e: any) => {
    //           if (e.key === 'Enter') {
    //             e.target.click()
    //           }
    //         }}
    //       >
    //         {TableRowNodes}
    //       </a>
    //     </HoverTextWrapper>
    //   )
    // }

    // return <HoverTextWrapper hoverText={hoverText}>{TableRowNodes}</HoverTextWrapper>
  }

  if (props.itemStatusMap && props.itemStatusMap[props.index] === 'loading') {
    return (
      <TableRowLoading
        viewBy={props.viewBy}
        equalWidthColumns={props.equalWidthColumns}
        style={props.style}
        headerGroups={props.headerGroups}
        columnWidthsObjectProp={props.columnWidthsObjectProp}
        columnWidthsObjectState={props.columnWidthsObjectState}
        isResizable={props.isResizable}
        tableRowAction={props.v2Features.tableRowAction}
        canFreezeCheckbox={props.canFreezeCheckbox}
        columns={props.columns}
      />
    )
  }

  return null
}

export default RenderRow